/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FilterInvertSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FilterInvertSmall',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"clipPath":"url(#wf-svg-filter-invert-small-a)","fillRule":"evenodd","clipRule":"evenodd","fill":"#D9D9D9"},createElement('path', {"opacity":".6","d":"M7 1V0H5v3.17a2.995 2.995 0 012 0V1zm-3.828.757l1.535 1.535a3.012 3.012 0 00-1.415 1.415L1.757 3.172l-.707-.708L2.464 1.05l.708.707zm5.656 8.486L7.293 8.708a3.013 3.013 0 001.415-1.415l1.535 1.535.707.708-1.414 1.414-.708-.707zM11 7H8.83a2.996 2.996 0 000-2H12v2h-1zm-.757-3.828L8.708 4.707a3.013 3.013 0 00-1.415-1.415l1.535-1.535.708-.707 1.414 1.414-.707.708z"}),createElement('path', {"d":"M6.95 7.05L2 12l-2-2 4.95-4.95C5.53 4.47 6.448 4.448 7 5c.552.552.53 1.47-.05 2.05z"})),createElement('defs', null,createElement('clipPath', {"id":"wf-svg-filter-invert-small-a"},createElement('path', {"fill":"#fff","d":"M0 0h12v12H0z"}))))
}
